import React from 'react';
import { useTranslation } from 'react-i18next';
import PricingRow from 'ui/atoms/PricingRow';
import { Text } from '@reservamos/elements';
import PropTypes from 'prop-types';
import passengerTypes from '../../config/passengerTypes';

/**
 * PurchasePricingBulk component.
 * @param {object} props - totalsPerCategory, globalTotal, globalTaxes, labelTaxes, labelTotal
 * @param {Array<{category: string, count: number, label: string, total: number}>} props.totalsPerCategory - Lista de totales por categoría
 * @param {number} props.globalTotal - Suma total global
 * @param {number} props.globalTaxes - Total de impuestos global
 * @param {string} props.labelTaxes - Etiqueta para los impuestos
 * @param {string} props.labelTotal - Etiqueta para el total
 * @param {string} props.labelBulkType - Etiqueta para el tipo de viaje
 */
const PurchasePricingBulk = ({
  totalsPerCategory,
  globalTotal,
  globalTaxes,
  labelTaxes,
  labelTotal,
  labelBulkType,
}) => {
  const { t } = useTranslation('passengers');

  /**
   * Returns the category label to be used.
   * @param {Object} totalsPer - Item to get
   * @param {Object} totalsPer.count - Number of tickets to be bought
   * @param {Object} totalsPer.category - Category of the ticket
   * @returns {string} - Label
   */
  const getLabel = (totalsPer) => {
    const { label } = passengerTypes[totalsPer.category === 'special' ? 'pcd' : totalsPer.category];
    return `${totalsPer.count} ${t(label)}`;
  };

  return (
    <div className="section-content">
      {labelBulkType && (
        <Text size="S" weight="bold" elementType="span">
          {labelBulkType}
        </Text>
      )}
      {totalsPerCategory?.map((item) => (
        <PricingRow key={item.category} label={getLabel(item)} price={item.subtotal} />
      ))}
      {labelTaxes && globalTaxes && (
        <PricingRow label={labelTaxes} price={globalTaxes.toString()} isMain />
      )}
      {labelTotal && globalTotal && (
        <PricingRow label={labelTotal} price={globalTotal.toString()} isMain />
      )}
    </div>
  );
};

PurchasePricingBulk.propTypes = {
  totalsPerCategory: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      total: PropTypes.number.isRequired,
    }),
  ),
  globalTotal: PropTypes.number,
  globalTaxes: PropTypes.number,
  labelTaxes: PropTypes.string,
  labelTotal: PropTypes.string,
  labelBulkType: PropTypes.string,
};

export default PurchasePricingBulk;
